const ANYWAY_EMAIL_DOMAINS = ['@year13.com.au', '@careertools.com.au', '@anyway.ai'];

export const isAnywayEmail = (email: string | null | undefined): boolean => {
  if (!email) {
    return false;
  }
  const lower = email.toLowerCase();
  return ANYWAY_EMAIL_DOMAINS.some(domain => lower.endsWith(domain));
};
